import { TProps } from './types/TProps';

export const DiffText = ({ parts, side }: TProps) => {
  const highlightClassName =
    side === 'before'
      ? 'rounded-[3px] bg-[var(--color-error-surface)] px-[1px] text-[var(--color-error-body)]'
      : 'rounded-[3px] bg-[var(--color-success-bg)] px-[1px] text-[var(--color-success-text)]';

  if (!parts.length) {
    return <> </>;
  }

  return (
    <>
      {parts.map((part, index) =>
        part.changed && part.text.trim() ? (
          <span className={highlightClassName} key={`${side}-${index}-${part.text}`}>
            {part.text}
          </span>
        ) : (
          <span key={`${side}-${index}-${part.text}`}>{part.text}</span>
        ),
      )}
    </>
  );
};
